import { API } from "aws-amplify";
import { apiGateway } from "../../config";
import { store } from "../";
import {
  ADD_PARTNER_ACCOUNTS,
  ADD_PARTNER_INVITES,
  FETCHED_PARTNER_ACCOUNTS,
  FETCHED_PARTNER_INVITES,
  FETCHING_PARTNER_ACCOUNTS,
  FETCHING_PARTNER_INVITES,
  UPDATE_PARTNER_INVITE,
  ADD_POPULATION_HEALTH,
  FETCHING_POPULATION_HEALTH,
  FETCHED_POPULATION_HEALTH
} from "./constants";
import debug from "../../utilities/debug";
const Gateway = apiGateway.find((gateway) => gateway.name === "client");

export const getPartnerAccounts = (override) => async (dispatch) => {
  if ((!store.getState().partners.fetchingAccounts && !store.getState().partners.fetchedAccounts) || override) {
    dispatch({ type: FETCHING_PARTNER_ACCOUNTS, payload: true });
    return API.get(Gateway.name, `/partners/get-accounts/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: ADD_PARTNER_ACCOUNTS, payload: { list: data.payload } });
        dispatch({ type: FETCHING_PARTNER_ACCOUNTS, payload: false });
        dispatch({ type: FETCHED_PARTNER_ACCOUNTS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: ADD_PARTNER_ACCOUNTS, payload: { list: [] } });
        dispatch({ type: FETCHING_PARTNER_ACCOUNTS, payload: false });
        dispatch({ type: FETCHED_PARTNER_ACCOUNTS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  } else {
    return { success: true, payload: store.getState().partners.list };
  }
};

export const getPartnerInvites = (override) => async (dispatch) => {
  if ((!store.getState().partners.fetchingInvites && !store.getState().partners.fetchedInvites) || override) {
    dispatch({ type: FETCHING_PARTNER_INVITES, payload: true });
    return API.get(Gateway.name, `/partners/get-invites/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: ADD_PARTNER_INVITES, payload: data.payload });
        dispatch({ type: FETCHING_PARTNER_INVITES, payload: false });
        dispatch({ type: FETCHED_PARTNER_INVITES, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: ADD_PARTNER_INVITES, payload: [] });
        dispatch({ type: FETCHING_PARTNER_INVITES, payload: false });
        dispatch({ type: FETCHED_PARTNER_INVITES, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  } else {
    return { success: true, payload: store.getState().partners.list };
  }
};

export const sendInviteBatch = async (invites, action = "send") => {
  return API.post(
    Gateway.name,
    `/partners/invite/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      },
      body: {
        invites,
        action
      }
    })
    .then((response) => {
      if (action === "resend") for (let invite of invites) store.dispatch({ type: UPDATE_PARTNER_INVITE, payload: { ...invite, status: "resent" }});
      return response;
    })
    .catch((error) => {
      debug.error('Partner API error', error);
      return { success: false, message: error.response && error.response.data ? error.response.data.message : "Something went wrong." };
    });
};

export const deleteInvite = (invite) => async (dispatch) => {
  return API.del(
    Gateway.name,
    `/partners/delete-invite/${invite}/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      }
    })
    .then((response) => {
      dispatch({ type: UPDATE_PARTNER_INVITE, payload: response.payload });
      return response;
    })
    .catch((error) => {
      debug.error('Partner API error', error);
      return { success: false, message: error.response && error.response.data ? error.response.data.message : "Something went wrong." };
    });
};

export const getPopulationHealth = (override = false) => async (dispatch) => {
  const state = store.getState();
  if (state.partners.fetchedPopulationHealth && !override) return;
  dispatch({ type: FETCHING_POPULATION_HEALTH, payload: true });
  return API.get(
    Gateway.name,
    `/partners/get-population-health/${state.session.account.account_id}/${state.authentication.user.cognito_id}`,
    { headers: { Authorization: state.session.token } }
  )
    .then((data) => {
      dispatch({ type: ADD_POPULATION_HEALTH, payload: data.payload });
      dispatch({ type: FETCHING_POPULATION_HEALTH, payload: false });
      dispatch({ type: FETCHED_POPULATION_HEALTH, payload: true });
      return data;
    })
    .catch(() => {
      dispatch({ type: FETCHING_POPULATION_HEALTH, payload: false });
      dispatch({ type: FETCHED_POPULATION_HEALTH, payload: true });
    });
};

export const lookupNPI = async ({ npi_number, first_name, last_name, phone }) => {
  return API.post(Gateway.name, `/partners/lookup-npi`, {
    body: {
      npi_number,
      first_name,
      last_name,
      phone
    }
  })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      debug.error('NPI lookup error', error);
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Failed to lookup NPI"
      };
    });
};